const isUnlimited = (val) => {
    if(val) {
        return true
    } else {
        return '请输入内容'
    }
}

const isNumber = (val) => {
    console.log('val :>> ', val);
    if (!isNaN(parseInt(val)) && isFinite(val)) {
        return true
    } else {
        return '输入有误，请输入数字'
    }
}

const isLetter = (val) => {
    // if(val) {
        let reg = /^[a-zA-Z]*$/
        if (reg.test(val)) {
            return true
        } else {
            return '请输入大写或小写字母'
        }
}

const isChinese = (val) => {
    let reg = /^[\u4e00-\u9fa5]{0,}$/
    if (reg.test(val)) {
        return true
    } else {
        return '请输入汉字'
    }
}

const isEmail = (val) => {
    let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
    if (reg.test(val)) {
        return true
    } else {
        return '请输入正确的邮箱地址'
    }
    
}

const isPhone = (val) => {
    // let reg = /^1[3456789]\d{9}$/ 手机号
    
    // mlxy 手机号验证改成 验证数字、+、-
    console.log('val :>> ', val);
    let reg = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/
    if (reg.test(val)) {
        return true
    } else {
        return '请输入正确的手机号'
    }
}

const isHttp = (val) => {
    console.log(val)
    let reg = /^(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]$/
    if (reg.test(val)) {
        return true
    } else {
        return '请输入正确的网址'
    }
}

const isIDNO = (val) => {
    let reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    if (reg.test(val)) {
        return true
    } else {
        return '身份证号格式错误'
    }
}
export {
    isUnlimited,
    isNumber,
    isLetter,
    isChinese,
    isEmail,
    isPhone,
    isHttp,
    isIDNO
} 